import { useState, useEffect } from 'react';
import { IoIosMenu, IoIosClose } from 'react-icons/io';
import data from './data';
import './navbar.css';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    let lastScrollY = window.scrollY;

    const handleScroll = () => {
      const currentY = window.scrollY;
      setScrolled(currentY > 16);

      if (isMenuOpen) {
        setHidden(false);
        lastScrollY = currentY;
        return;
      }

      if (currentY < 80) {
        setHidden(false);
      } else if (currentY > lastScrollY + 8) {
        setHidden(true);
      } else if (currentY < lastScrollY - 8) {
        setHidden(false);
      }

      lastScrollY = currentY;
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isMenuOpen]);

  // Handle mobile menu toggle
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Close menu when clicking on a link
  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <>
      <nav
        className={`navbar ${scrolled ? 'navbar--scrolled' : ''} ${hidden ? 'navbar--hidden' : ''}`}
        aria-label="Navigasi utama"
      >
        <div className="container">
          <div className="navbar__container">
            {/* Logo */}
            <a href="#header" className="navbar__logo" aria-label="Kembali ke beranda">
              <span className="navbar__logo-text">iTechservice.id</span>
            </a>

            {/* Desktop Navigation */}
            <ul className="navbar__menu" role="menubar">
              {data.map((item) => (
                <li key={item.id} role="none">
                  <a 
                    href={item.link} 
                    className="navbar__link"
                    role="menuitem"
                    onClick={closeMenu}
                  >
                    {item.title}
                  </a>
                </li>
              ))}
            </ul>

            {/* Desktop Actions */}
            <div className="navbar__actions">
              <button 
                className="navbar__menu-toggle" 
                onClick={toggleMenu}
                aria-label={isMenuOpen ? 'Tutup menu' : 'Buka menu'}
                aria-expanded={isMenuOpen}
              >
                {isMenuOpen ? <IoIosClose /> : <IoIosMenu />}
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      <div className={`navbar__overlay ${isMenuOpen ? 'navbar__overlay--open' : ''}`}>
        <div className="navbar__mobile-menu" role="dialog" aria-modal="true" aria-label="Menu navigasi mobile">
          <div className="navbar__mobile-header">
            <span className="navbar__mobile-logo">iTech</span>
            <button 
              className="navbar__mobile-close" 
              onClick={closeMenu}
              aria-label="Tutup menu"
            >
              <IoIosClose />
            </button>
          </div>
          
          <nav className="navbar__mobile-nav" aria-label="Navigasi mobile">
            <ul className="navbar__mobile-list" role="menubar">
              {data.map((item) => (
                <li key={item.id} role="none">
                  <a 
                    href={item.link} 
                    className="navbar__mobile-link"
                    role="menuitem"
                    onClick={closeMenu}
                  >
                    {item.title}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </div>
    </>
  );
};

export default Navbar;
